import { type SVGAttributes } from "react";
import { cn } from "./cn";

/** Indeterminate loading spinner. Inherits `currentColor`; size via `className`. */
export function Spinner({ className, ...props }: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      className={cn("animate-spin h-4 w-4 text-current", className)}
      viewBox="0 0 24 24"
      fill="none"
      role="status"
      aria-label="Indlæser"
      {...props}
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  );
}
